"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerFaultCategory = void 0;
var ChargerFaultCategory;
(function (ChargerFaultCategory) {
    ChargerFaultCategory[ChargerFaultCategory["SoftwareFault"] = 1] = "SoftwareFault";
    ChargerFaultCategory[ChargerFaultCategory["ChargerFault"] = 2] = "ChargerFault";
    ChargerFaultCategory[ChargerFaultCategory["DriverInducedFault"] = 3] = "DriverInducedFault";
})(ChargerFaultCategory = exports.ChargerFaultCategory || (exports.ChargerFaultCategory = {}));
